import React from 'react';
import EditableContentMultilang from '../components/EditableContentMultilang';
import './LegalPage.css'; // Usa un CSS condiviso per le pagine legali

const PrivacyPolicyPage = () => {
    return (
                    <div className="legal-page">
                <section className="page-header">
                    <div className="container">
                        <EditableContentMultilang 
                            docPath="privacy_policy_page/header" 
                            field="title" 
                            elementType="h1"
                            placeholder="Privacy Policy"
                        />
                    </div>
                </section>
                <section className="content-section">
                    <div className="container legal-text-container">
                        <EditableContentMultilang 
                            docPath="privacy_policy_page/content" 
                            field="main_text" 
                            elementType="textarea" // Usa textarea per testo lungo
                            placeholder="[ Inserisci qui il testo completo della tua Privacy Policy... ]"
                        />
                    </div>
                </section>
            </div>
    );
};

export default PrivacyPolicyPage;

